// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"2a0c5711","796":"18a7ae6d"}[chunkId] + ".chunk.js";
};